export default () => ({
    wrapperState: false,
    scrollable: false,
    init() {
        this.$watch('wrapperState', (value) => {
            if (value) {
                setTimeout(() => {
                    if (this.$refs.content.scrollHeight > window.innerHeight) {
                        this.scrollable = true;
                        this.$root.scrollTop = 0;
                    }
                }, 10);
            }
        })
    }
});